export const companies = {
  title: 'Companies',
  resourceName: 'Companies',
  titles: {
    list: 'Company Management',
    create: 'Create company',
    edit: 'Edit company',
    detail: 'Company details',
    view: 'Company detail',
    addQuick: 'Add quick',
  },
  sections: {
    basic: 'Basic information',
    note: 'Notes',
    audit: 'System',
  },
  fields: {
    code: 'Company code',
    name: 'Company name',
    country: 'Country',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    isActive: 'Operating status',
    onOffAction: 'On / Off',
    note: 'Note',
    actions: 'Actions',
  },
  countries: {
    VietNam: 'Vietnam',
    TrungQuoc: 'China',
    HanQuoc: 'South Korea',
    NhatBan: 'Japan',
    Singapore: 'Singapore',
    ThaiLan: 'Thailand',
    DaiLoan: 'Taiwan',
    HongKong: 'Hong Kong',
    My: 'United States',
    Duc: 'Germany',
    Anh: 'United Kingdom',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
  },
  sortFields: {
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    tenCongTy: 'Company name',
    maCongTy: 'Company code',
    quocGia: 'Country',
  },
  filter: {
    search: 'Search',
    searchPlaceholder: 'Code or company name',
    status: 'Status',
    statusAll: 'All',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    sortField: 'Sort by',
    sortDirection: 'Order',
    sortAsc: 'Ascending',
    sortDesc: 'Descending',
  },
  validation: {
    codeNameRequired: 'Please enter company code and company name',
    codeDuplicated: 'Company code already exists',
    codeFormat: 'Company code may only contain letters, digits, hyphen and underscore',
  },
  messages: {
    noData: 'No company data',
    totalCompanies: 'Total: {total} companies',
    saving: 'Saving...',
    savedSuccess: 'Saved successfully',
    createSuccess: 'Company created successfully',
    updateSuccess: 'Company updated successfully',
    deleteSuccess: 'Company deleted successfully',
    statusToggleSuccess: 'Company status updated',
    confirmDelete: 'Are you sure you want to delete this company?',
    notFound: 'Company not found',
    loadDetailError: 'Could not load company details',
  },
}
